import type { ComponentProps } from 'react'

import ProductGalleryV3 from './ProductGalleryv3/ProductGalleryv3'

type ProductGalleryProps = ComponentProps<typeof ProductGalleryV3>

export default function ProductGallery(props: ProductGalleryProps) {
  const Component = ProductGalleryV3

  return <Component {...props} />
}
